<template>
	<div class="login-layout">
		<div class="content">
			<div class="top">
				<div class="header">
					<img alt="logo" class="logo" src="@/assets/logo.svg" />
					<span class="title">Boss Admin</span>
				</div>
			</div>
			<div class="login">
				<a-form-model ref="adminForm" :model="form" @submit.native.prevent="onSubmit">
					<a-alert type="error" :closable="true" v-show="error" :message="error" showIcon
						style="margin-bottom:24px;" />
					<a-form-model-item prop="account"
						:rules="[{ required: true, message: '请输入账号', whitespace: true, trigger: 'blur' }]">
						<a-input v-model="form.account" autocomplete="autocomplete" size="large" placeholder="邮箱/手机号">
							<a-icon slot="prefix" type="user" />
						</a-input>
					</a-form-model-item>
					<a-form-model-item prop="password"
						:rules="[{ required: true, message: '请输入登录密码', whitespace: true, trigger: 'blur' }]">
						<a-input v-model="form.password" size="large" type="password" placeholder="请输入登录密码">
							<a-icon slot="prefix" type="lock" />
						</a-input>
					</a-form-model-item>

					<div class="google-code-box" v-if="googleAuthLogin">
						<a-form-model-item prop="code"
							:rules="codeRules">
							<a-input v-model="form.code" size="large" type="text" :maxLength="6" placeholder="请输入谷歌动态码">
								<a-icon slot="prefix" type="google" />
							</a-input>
						</a-form-model-item>
					</div>

					<a-form-model-item>
						<a-button :loading="logging" style="width:100%;" size="large" htmlType="submit"
							type="primary">登录</a-button>
					</a-form-model-item>
				</a-form-model>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		setToken
	} from '@/utils/request';
	import {
		login,
		googleAuthIsOpen
	} from '@/api/app';
	export default {
		data() {
			return {
				logging: false,
				error: '',
				form: {
					account: '',
					password: '',
					code: ''
				},
				googleAuthLogin: false,
				googleVisible: false
			}
		},
		computed: {
			codeRules() {
				if (!this.googleAuthLogin) {
					return [];
				}
				return [
					{ required: true, message: '请输入谷歌动态码', trigger: 'blur' },
					{ pattern: /^\d{0,6}$/, message: '只能输入6位数字', trigger: 'blur' }
				];
			}
		},
		created() {
			this.googleAuthIsOpen();
		},
		methods: {
			onSubmit() {
				this.$refs.adminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					this.logging = true;
					const params = {
						account: this.form.account,
						password: this.form.password,
						code: this.form.code
					};
					login(params).then(this.afterLogin);
				});
			},
			afterLogin(res) {
				if (res.isSucceed) {
					console.log(res.data.token);
					setToken(res.data.token);
					this.$router.push('/workplace');
				} else {
					this.logging = false;
					this.error = res.message;
				}
			},
			googleAuthIsOpen() {
				let that = this;
				googleAuthIsOpen().then(function(res) {
					that.googleAuthLogin = res.data.googleAuthIsOpen;
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.login-layout {
		display: flex;
		flex-direction: column;
		height: 100vh;
		overflow: auto;
		// background-color: @layout-body-background;
		background-color: #f8f8f8;
		background-image: url('../assets/background.svg');
		background-repeat: no-repeat;
		background-position-x: center;
		background-position-y: 110px;
		background-size: 100%;

		.content {
			padding: 32px 0;
			flex: 1;

			@media (min-width: 768px) {
				padding: 112px 0 24px;
			}

			.top {
				text-align: center;

				.header {
					height: 44px;
					line-height: 44px;
					margin-bottom: 30px;

					.logo {
						height: 44px;
						vertical-align: top;
						margin-right: 16px;
					}

					.title {
						font-size: 33px;
						color: #222;
						font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
						font-weight: 600;
						position: relative;
						top: 2px;
					}
				}
			}
		}

		.login {
			width: 328px;
			margin: 0 auto;

			.icon {
				font-size: 24px;
				color: #ccc;
				margin-left: 16px;
				vertical-align: middle;
				cursor: pointer;
				transition: color 0.3s;

				&:hover {
					color: #ccc;
				}
			}
		}
	}
</style>
